// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "SelfServGroupWriteDto" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { SelfServMode } from "./self-serv-mode.enum.gen";
import { ChatWorkflowRefGenShape } from "./chat-workflow-ref.gen";

export const SelfServGroupWriteDtoGenShape = z.strictObject({
  name: z.string(),
  libraryId: z.string(),
  treeId: z.string(),
  mode: z.enum(SelfServMode).optional(),
  workflow: ChatWorkflowRefGenShape.optional(),
  showFeedback: z.boolean().optional(),
});
